var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#767571",
  fillRule: "evenodd",
  d: "M1.209 0C.541 0 0 .541 0 1.209v15.582C0 17.459.541 18 1.209 18h15.582c.668 0 1.209-.541 1.209-1.209V1.209C18 .541 17.459 0 16.791 0zm4.366 3.996a1.578 1.578 0 1 1-3.157 0 1.578 1.578 0 0 1 3.157 0m4.164 3.761c.302-.604 1.315-1.33 2.552-1.276 1.5.065 2.047.67 2.357 1.012l.027.03c.295.324.504.907.638 1.545.087.412.063 3.022.045 5.02-.005.479-.009.923-.011 1.293H12.66v-5.038c-.022-.358-.223-1.23-.906-1.376-.84-.18-1.31.055-1.579.369-.403.47-.436 1.074-.436 1.477v4.568H7.052V6.716H9.74zm-7.052 7.624V6.716h2.686v8.665z",
  clipRule: "evenodd"
})));
export default SvgLinkedin;